var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useAPI } from "..";
import { toaster } from "evergreen-ui";
import { AFolder, ABook } from "./Things";
import * as React from "react";
import { ServerPath } from "../ServerPath";
export const LibraryContext = React.createContext(null);
export function useLibrary() {
    const context = React.useContext(LibraryContext);
    if (context === undefined) {
        throw new Error("Context must be used within a Provider");
    }
    return context;
}
class FileNameSize {
}
class FolderData {
}
function APIloadLibrary(API, updateCallback) {
    return __awaiter(this, void 0, void 0, function* () {
        var tmplibrary = [];
        let count = 1;
        let total = 0;
        let processfolder = (parent, files, path) => {
            if (!files)
                return [];
            let fiesInFolder = Object.keys(files);
            total = total + fiesInFolder.length;
            let c = fiesInFolder.map((f) => {
                let t = files[f];
                if (!!t.name) {
                    return [
                        API.jsonFetch("files/" + ServerPath([...path, t.name]))
                            .catch((e) => {
                            console.error(e);
                            return false;
                        })
                            .then((filedata) => {
                            if (!filedata)
                                return;
                            if (!filedata.data)
                                return;
                            let d = new ABook(t.name, filedata.data.content, filedata.data.svg, filedata.data.info);
                            parent.addChildren([d]);
                            tmplibrary.push(d);
                            updateCallback(count++, total);
                            return d;
                        }),
                    ];
                }
                t = t;
                let d = new AFolder(f);
                parent.addChildren([d]);
                tmplibrary.push(d);
                updateCallback(count++, total);
                return processfolder(d, t, [...path, f]);
            });
            return c.flat();
        };
        const RootProject = new AFolder(API.name + "'s Projects");
        let res = yield API.jsonFetch("files").catch((err) => {
            console.error(err);
            return false;
        });
        if (!res || !res.data) {
            toaster.danger("Failed to load library");
            return [RootProject];
        }
        yield Promise.all(processfolder(RootProject, res.data, []));
        return [RootProject, ...tmplibrary];
    });
}
function APInewFolder(API, named) {
    return API.jsonPost("files/folder", { named }).then((r) => {
        let named = r.data.named;
        toaster.success("Folder Created, " + named);
        return named;
    });
}
function APIdeleteFolder(API, named) {
    return API.jsonPost("files/folder", { delete: named }).then((r) => {
        let named = r.data.named;
        toaster.warning("Deleted, " + named);
        return named;
    });
}
function APIrenameFile(API, fromfile, filename) {
    return __awaiter(this, void 0, void 0, function* () {
        // console.log("FROM: ", fromfile, "FILENAME: ", filename);
        let formData = new FormData();
        formData.append("fromfile", fromfile);
        formData.append("file", filename);
        let res = yield API.jsonPost("files/" + filename + "?from=" + fromfile, formData, true);
        // console.log(res);
        toaster.success(`Renamed File ` + res.data.filename);
        return res.data;
    });
}
function APIdeleteFile(API, file) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!file)
            return toaster.danger("No File to Delete");
        let formData = new FormData();
        let res = yield API.jsonPost("files/" + file, formData, false, "DELETE");
        toaster.success(`File ${file} deleted`);
        return res.data;
    });
}
function APIsavePref(API, book) {
    return __awaiter(this, void 0, void 0, function* () {
        // console.log("APISAVEPREF CALLED");
        let tempbook = new ABook("", "", "", false);
        book = Object.assign(tempbook, book);
        book.fixFolders();
        let filename = book.folder.path();
        filename.push(book.filename);
        //book, ServerPath(filename)
        let res = yield API.jsonPost("files/" + ServerPath(filename) + "/param", { book: book }, false, "PUT");
        // console.log("Res: ", res);
        return res.data;
    });
}
// savePref: (book: ABook) => {
// },
export function LibraryProvider(props) {
    let API = useAPI();
    const [LibraryItems, setLibraryItems] = React.useState(null);
    const [current, setCurrent] = React.useState(null);
    const [max, setMax] = React.useState(null);
    const [loading, setLoading] = React.useState(false);
    // let hasLibrary = () => {
    //     if (!LibraryItems) reloadLibrary();
    //     return LibraryItems;
    // }
    let clearLibrary = () => {
        setLibraryItems(null);
        setCurrent(null);
        setMax(null);
    };
    let reloadLibrary = () => __awaiter(this, void 0, void 0, function* () {
        if (loading) {
            return;
        }
        setLoading(true);
        const l = yield APIloadLibrary(API, (current, max) => {
            setCurrent(current);
            setMax(max);
        });
        setLibraryItems([...l]);
        setLoading(false);
    });
    let indexOf = (key) => {
        return (LibraryItems || []).map((v) => v.key).indexOf(key);
    };
    let indexOfBook = (key) => {
        return (LibraryItems || []).findIndex((v) => v.equal ? v.equal(key) : false);
    };
    let findChildFolder = (parent, named) => {
        if (!parent || !LibraryItems)
            return null;
        let children = LibraryItems.filter((v) => v.folder && //i don't know why there aare nulls in here
            v.type == "folder" &&
            v.folder.filename == parent.filename);
        return children.filter((v) => v.filename == named).pop();
    };
    let findChildFromPath = (path) => {
        const findChildren = (parent) => {
            if (!LibraryItems)
                return [];
            return LibraryItems.filter((v) => { var _a; return ((_a = v.folder) === null || _a === void 0 ? void 0 : _a.key) === parent.key; });
        };
        if (path.length <= 0)
            return null;
        path = [...path].reverse();
        let filename = path[0];
        let currentPath = path.pop();
        let parent = LibraryItems[0];
        while (currentPath) {
            const children = findChildren(parent);
            const child = children.find((v) => v.filename === filename);
            if (child)
                return child; //cbf
            parent = findChildFolder(parent, currentPath);
            currentPath = path.pop();
        }
        return null;
    };
    let indexFromPath = (path) => {
        if (path.length <= 0)
            return 0;
        path = path.reverse();
        // console.log(path);
        let c = path.pop();
        let p = LibraryItems[0];
        while (c) {
            p = findChildFolder(p, c);
            c = path.pop();
        }
        if (!p)
            return 0;
        return indexOf(p.key);
    };
    // let removeItem = async (file: AThing) => {
    //   let filename = file.folder.path();
    //   filename.push(file.filename);
    //   const res = await APIdeleteFile(API, ServerPath(filename));
    //   if (res) {
    //     let l = LibraryItems.filter((v: AThing) => v.key != file.key);
    //     setLibraryItems([...l]);
    //   } else {
    //     toaster.warning("Failed to delete file, " + file.filename);
    //   }
    // };
    let removeItem = (files) => __awaiter(this, void 0, void 0, function* () {
        if (!Array.isArray(files)) {
            files = [files]; // Convert single file to an array
        }
        const deletionPromises = files.map((file) => __awaiter(this, void 0, void 0, function* () {
            let filename = file.folder.path();
            filename.push(file.filename);
            const res = yield APIdeleteFile(API, ServerPath(filename));
            if (res) {
                return file.key;
            }
            else {
                toaster.warning("Failed to delete file, " + file.filename);
                return null;
            }
        }));
        const deletedKeys = yield Promise.all(deletionPromises);
        // Filter out null values (failed deletions) and update the LibraryItems state
        const updatedLibraryItems = LibraryItems.filter((item) => !deletedKeys.includes(item.key));
        setLibraryItems(updatedLibraryItems);
    });
    let renameItem = (book, newname) => __awaiter(this, void 0, void 0, function* () {
        let oldpath = book.path();
        let newpath = [...oldpath];
        newpath[newpath.length - 1] = newname;
        yield APIrenameFile(API, ServerPath(oldpath), ServerPath(newpath));
        let i = indexOf(book.key);
        if (i >= 0)
            LibraryItems[i].display = newname;
        setLibraryItems([...LibraryItems]);
        reloadLibrary();
    });
    let moveItem = (folder, book) => __awaiter(this, void 0, void 0, function* () {
        let newpath = folder.path();
        // newpath.push( book.filename);
        newpath.push(book.display);
        yield APIrenameFile(API, ServerPath(book.path()), ServerPath(newpath));
        let i = indexOf(book.key);
        if (i >= 0)
            LibraryItems[i].folder = folder;
        setLibraryItems([...LibraryItems]);
    });
    let updateThing = (book) => __awaiter(this, void 0, void 0, function* () {
        if (!book.key)
            throw new Error("book does not look like a thing");
        // console.log('updateThing', book)
        let i = indexOfBook(book);
        // console.log('update', i , book)
        if (i < 0)
            return false;
        const res = yield APIsavePref(API, book);
        if (!res) {
            return toaster.danger("An error has occurred, please try again. If this error persists, please contact Duraproducts.");
        }
        if (i >= 0)
            LibraryItems[i] = book;
        setLibraryItems([...LibraryItems]);
        return res;
    });
    const UpdateNotes = (book, notes) => __awaiter(this, void 0, void 0, function* () {
        // console.log("UpdateNotes", book, notes);
        book.notes = notes;
        yield updateThing(book);
        toaster.success("Note saved");
    });
    //returns a promise of the new key
    let newFolder = (named, parent) => __awaiter(this, void 0, void 0, function* () {
        let p = parent.path();
        p.push(named);
        const named_1 = yield APInewFolder(API, ServerPath(p));
        let b = new AFolder(named_1);
        parent.addChildren([b]);
        LibraryItems.push(b);
        setLibraryItems([...LibraryItems]);
        return b;
    });
    let deleteFolder = (folder) => __awaiter(this, void 0, void 0, function* () {
        const res = yield APIdeleteFolder(API, ServerPath(folder.path()));
        if (res)
            setLibraryItems([
                ...LibraryItems.filter((v) => v.key != folder.key),
            ]);
        return res;
    });
    let uploadFile = (file, filename) => __awaiter(this, void 0, void 0, function* () {
        if (!file)
            return toaster.danger("No Upload File");
        filename = ServerPath(filename);
        if (!filename)
            throw new Error("No Filename on upload");
        // console.log("uploadFile: ", filename);
        let formData = new FormData();
        formData.append("file", file);
        formData.append("filename", filename);
        let res = yield API.jsonPost("files/" + filename, formData, true);
        toaster.success(`Upload ${file.name}`);
        return res.data;
    });
    let attachFile = (file, filename, dfxname) => __awaiter(this, void 0, void 0, function* () {
        // console.log("Going to route");
        if (!file)
            return toaster.danger("No Upload File");
        filename = ServerPath(filename);
        // console.log("uploadFile: ", filename);
        let formData = new FormData();
        formData.append("file", file);
        formData.append("filename", filename);
        let res = yield API.jsonPost("files/attach/" + dfxname + "/" + filename, formData, true);
        toaster.success(`Upload ${file.name}`);
        return res.data;
    });
    let renameFolder = (folder, newName) => __awaiter(this, void 0, void 0, function* () {
        return API.jsonPost("files/folder", {
            named: ServerPath(folder.path()),
            rename: ServerPath(newName),
        }).then((r) => {
            if (r.error) {
                // console.log("R.ERROR FUNC");
                toaster.danger(r.error.description);
                return false;
            }
            let named = r && r.data ? r.data.named : "";
            toaster.success("Folder Moved, " + named);
            return named;
        });
    });
    const contextValue = {
        loading: { current: current, max: max },
        clear: clearLibrary,
        //    hasLibrary: hasLibrary,
        reloadLibrary: reloadLibrary,
        indexOf: indexOf,
        indexFromPath: indexFromPath,
        findChildFromPath: findChildFromPath,
        items: LibraryItems,
        remove: removeItem,
        rename: renameItem,
        move: moveItem,
        updateNotes: UpdateNotes,
        updateThing: updateThing,
        newFolder: newFolder,
        deleteFolder: deleteFolder,
        renameFolder: renameFolder,
        uploadFile: uploadFile,
        attachFile: attachFile,
    };
    return (React.createElement(LibraryContext.Provider, { value: contextValue }, props.children));
}
